if (typeof CKEDITOR != 'undefined') {
    CKEDITOR.plugins.setLang('nbsp', 'cs',
        {
            button: 'Vložit pevnou mezeru'

        }
    )
}